import strCounter from '@/tools/str_counter';
import { lexParse } from "@/tools/graphQueryConstructor";

export const CHART_MONTHS = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", 
  "Октябрь", "Ноябрь", "Декабрь"];

export const CHART_DEFAULT_COLORS = [
  "#9E7FB1", "#B888C0", "#D785A8", "#E68E85", "#EEC980", "#BDEBF5", "#B1D2ED", "#798FC8",
  "#7BA3BA", "#8D86B7", "#A982B8", "#E6757B", "#C1F1FD", "#C5E5F6", "#A1B8C4", "#A1A4E0",
  "#B0A8C8", "#B2A6D0", "#D69CB1", "#F3A69F", "#F4B9A3", "#F9E6A2", "#E8F9A4", "#F0F6A2",
  "#C1D4E6", "#B9BED5", "#B9B9F7", "#D6B0CF", "#FFB7B7", "#F1B3BB", "#FFD29F", "#E7D96A",
  "#D1C1DA", "#E2B6C4", "#D1A6E1", "#C2C9D9", "#A6B5C1", "#B2C1D6", "#C5A3E0", "#B1A1E3",
  "#C8B6F4", "#F7B8D3", "#D6D4F4", "#C9B4C1", "#D3A5F3", "#B9A9F2", "#D1E7FE", "#F5B5B5",
  "#F2C2F1", "#F9E4D9", "#A3B7F2", "#F8E9F6", "#F6C9E7", "#D0F1F0", "#B0C3C6", "#A9B0A3",
  "#F4C7FB", "#C3B5F5", "#9E85F2", "#F3A1FA", "#D9A5F5", "#F0BCFB", "#D7A2F4", "#A8A6E5",
  "#FFB9EA", "#F8E6F9", "#E8D2FD", "#D7A0F1", "#F2C5FE", "#E7B6F6", "#D3A9F7", "#E7A9F4",
  "#E3B9D9", "#FFB8F9", "#F1C1F1", "#D1A1F7", "#B4B5F3", "#D0C8FC", "#A2B4D3", "#F5D2EA",
  "#F4C9D7", "#D8F3E6", "#F1A1EC", "#A6ACF7", "#D2D1F4", "#C7C6F7", "#C1C0F1", "#D6A9E5",
  "#C4A5F5", "#D0D2F8", "#E6C6F7", "#E5D5F9", "#C0A9F9", "#D8A9F6", "#D7D9F4", "#F5A9F9",
  "#D6A6F4", "#D0C5E2", "#E2A3F2", "#D0D1FB", "#B1A9F8", "#F2D3D2", "#E8D9D5", "#D0E2F6",
  "#D9A7FC", "#D3A8F4", "#C6B5F8", "#E5B8F3", "#F5B9FF",
];

export function getDefaultColumnBarOptions(tooltipCounterTitle) {
  return {
    chart: {
      id: 'column-bar',
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      type: 'category',
      categories: CHART_MONTHS,
      decimalsInFloat: 2,
      labels: {
        style: {
          fontSize: '16px',
          fontFamily: 'Montserrat',
          fontWeight: 400,
        },
      },
    },
    yaxis: {
      type: 'category',
      min: 0,
      labels: {
        formatter: function(val, index) {
          return val.toFixed().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
        },
        style: {
          fontSize: '16px',
          fontFamily: 'Montserrat',
          fontWeight: 400,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      followCursor: true,
      custom: function({series, seriesIndex, dataPointIndex, w}) {
        const totalCount = series[seriesIndex][dataPointIndex];
        return `
          <div class="arrow-box">
            <span>${totalCount.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')}</span>
            <span>${strCounter(
              tooltipCounterTitle.word,
              tooltipCounterTitle.e1,
              tooltipCounterTitle.e2,
              tooltipCounterTitle.e3)(totalCount)}
            </span>
          </div>`;
      },
    },
  };
}

export function getDefaultBarOptions(options) {
  return {
    chart: {
      id: 'bar',
      toolbar: {
        show: false,
      },
      stacked: options.stacked || false,
    },
    yaxis: {
      type: 'category',
      labels: {
        maxWidth: 350,
        style: {
          fontSize: '14px',
          fontFamily: 'Montserrat',
          fontWeight: 600,
        },
      },
    },
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: '60%',
        barHeight: '60%',
      },
      stroke: {
        show: true,
        width: 11,
        colors: ['#fff'],
      },
    },
    xaxis: {
      type: 'numeric',
      min: 0,
      decimalsInFloat: 0,
      tickAmount: 6,
      labels: {
        formatter: function(val, index) {
          return val;
        },
        style: {
          fontSize: '16px',
          fontFamily: 'Montserrat',
          fontWeight: 400,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      followCursor: true,
      custom: function({series, seriesIndex, dataPointIndex, w}) {
        const totalEndedCount = series[seriesIndex][dataPointIndex];
        let totalStartedCount = 0;
        if(series[1]) {
          totalStartedCount = series[0][dataPointIndex] + series[1][dataPointIndex];
        }
        let lastWordTemplate = "";

        if(options.stacked && seriesIndex === 0) {
          lastWordTemplate = `, ${strCounter(
            'завершивш',
            'ий',
            'иe',
            'их',

          )(totalEndedCount)} прохождение курса`;
        } else if(options.stacked && seriesIndex === 1) {
          lastWordTemplate = `, ${strCounter(
            'начавш',
            'ий',
            'иe',
            'их',

          )(totalStartedCount)} прохождение курса`;;
        }
        return `
          <div class="arrow-box">
            <span>${(seriesIndex ? totalStartedCount : totalEndedCount).toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')}</span>
            <span>${strCounter(
              options.title.word,
              options.title.e1,
              options.title.e2,
              options.title.e3)(seriesIndex ? totalStartedCount : totalEndedCount )}${lastWordTemplate}
            </span>
          </div>`;
      },
    },
  };
}

export function getDefaultDonutOptions(labelList, options) {
  return {
    chart: {
      type: 'donut',
    },
    labels: labelList,
    dataLabels: {
      enabled: false,
    },
    colors: CHART_DEFAULT_COLORS,
    legend: {
      show: false,
    },
    tooltip: {
      enabled: true,
      followCursor: true,
      theme: 'light',
      style: {
        fontSize: '14px',
        lineHeight: '20px',
        fontFamily: 'Montserrat',
        borderRadius: '10px',
      },
      custom: function({series, seriesIndex, dataPointIndex, w}) {
        const totalCount = series[seriesIndex];
        return `
          <div class="arrow-box">
            <span>${totalCount.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')}
            (<span class="donut-chart-percent">${options[seriesIndex].persent}%</span>)</span>
            <span>
            <div>${options[seriesIndex].listItemTitle}</div>
            </span>
          </div>`;
      },
    },
  };
}

export function gQueryOptionsTemplate(
  hasUserContactsAccess,
  apolloSearchString,
  userSearchFilters,
  selectedTags,
  type,
  year,
  projectId = "",
) {
  let searchData;
  const options = {
      withoutContacts: !hasUserContactsAccess,
  };

  try {
      searchData = lexParse(apolloSearchString, options);
  } catch (e) {
      searchData = '';
      console.error(e);
  }
  return [
    userSearchFilters,
    searchData,
    options,
    selectedTags,
    {
      type: type,
      options: {
        year: year,
        projectId,
      },
    },
  ];
};
